import { useNavigate } from 'react-router-dom';
import campana from '../../assets/campana.png';
import perfil from '../../assets/perfil.jpg';
import useAuth from '../../hooks/useAuth';
import { useUsuario } from '../../context/UsuarioContext';

const OCUPACION_LABELS = {
  EMPLEADO: 'Empleado',
  INDEPENDIENTE: 'Independiente',
  EMPRESARIO: 'Empresario',
  ESTUDIANTE: 'Estudiante',
  HOGAR: 'Oficios del hogar',
  PENSIONADO: 'Pensionado',
  DESEMPLEADO: 'Desempleado',
  OTRO: 'Otro',
};

const toTitleCase = (value) =>
  value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const buildDisplayName = (usuario, profile) => {
  const fromUsuario = [
    usuario?.primerNombre?.trim(),
    usuario?.primerApellido?.trim(),
  ].filter(Boolean);

  if (fromUsuario.length > 0) {
    return fromUsuario.join(' ');
  }

  const profileFirst = profile?.primerNombre ?? profile?.given_name;
  const profileLast = profile?.primerApellido ?? profile?.family_name;
  const fromProfile = [profileFirst, profileLast]
    .map((part) => (typeof part === 'string' ? part.trim() : null))
    .filter(Boolean);

  if (fromProfile.length > 0) {
    return fromProfile.join(' ');
  }

  if (typeof profile?.name === 'string' && profile.name.trim().length > 0) {
    return profile.name.trim();
  }

  return 'Usuario';
};

const buildRoleLabel = (usuario) => {
  if (usuario?.profesion?.nombre) {
    return usuario.profesion.nombre;
  }

  if (usuario?.ocupacion && typeof usuario.ocupacion === 'string') {
    return OCUPACION_LABELS[usuario.ocupacion] ?? toTitleCase(usuario.ocupacion);
  }

  return 'Usuario';
};

const UserPanel = () => {
  const { logout, profile } = useAuth();
  const { usuario } = useUsuario();
  const navigate = useNavigate();
  const displayName = buildDisplayName(usuario, profile);
  const roleLabel = buildRoleLabel(usuario);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.warn('No se pudo cerrar sesión desde el panel de usuario', error);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-6 bg-[#002E6D] text-white px-12 pb-3 pt-4 rounded-bl-xl">
      <button
        type="button"
        className="bg-[#0054c9] px-3 py-3 rounded-xl text-sm font-bold transition hover:bg-[#2f6edc] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0054c9]"
      >
        Solicitar asesoría
      </button>
      <div className="text-xs">
        <div className="font-bold text-[#c1dbff] pb-2 text-lg">Caja activa</div>
        <div className="text-lg font-bold">Personas</div>
      </div>
      <div className="text-xs">
        <div className="font-bold text-[#c1dbff] pb-2 text-lg">Balance:</div>
        <div className="text-lg font-bold">COP: 1,000,990</div>
      </div>
      <img src={campana} alt="Campana" className="w-6" />
      <div className="flex items-center gap-3 rounded-xl bg-white/5 px-4 py-2">
        <img
          src={perfil}
          alt={displayName}
          className="w-16 h-16 rounded-full border-2 border-blue-400/60"
        />
        <div className="text-xs">
          <div className="font-bold text-lg m-0 p-0">
            {displayName}
          </div>
          <div className="text-[#acb9ca] font-bold m-0 p-0">
            {roleLabel}
          </div>
          <div className="mt-3 flex flex-col gap-2">
            <button
              type="button"
              className="bg-blue-500 text-white rounded-lg px-3 py-1 text-sm font-bold transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400"
              onClick={() => navigate('/personas/dashboard/mi-cuenta')}
            >
              Mi cuenta
            </button>
            <button
              type="button"
              onClick={handleLogout}
              className="rounded-lg border border-white/40 bg-white/10 px-3 py-1 text-sm font-bold text-white transition hover:bg-white hover:text-[#002E6D] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPanel;
